import { application } from "./application"

import DynamicRolesController from "./dynamic_roles_controller"
application.register("dynamic-roles", DynamicRolesController)

import DynamicLinksController from "./dynamic_links_controller"
application.register("dynamic-links", DynamicLinksController)

import ToggleIsrcController from "./toggle_isrc_controller"
application.register("toggle-isrc", ToggleIsrcController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import TrackCountController from "./track_count_controller"
application.register("track-count", TrackCountController)

import SubmitOverlayController from "./submit_overlay_controller"
application.register("submit-overlay", SubmitOverlayController)

import ImportStatusController from "./import_status_controller"
application.register("import-status", ImportStatusController)
